import React from 'react';
import styled from 'styled-components';
import Input from '@qc/particle/lib/components/input';

import { executeRules, REQUIREMENTS } from '../constants/password';

export const Ul = styled.ul`
  list-style-type: none;
  padding-bottom: 0;
  margin-bottom: 0;

  li {
    font-size: 12px;
  }
`;

export const LiContainer = styled.span`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

export const Circle = styled.span`
  background-color: var(--gray-6);
  border-radius: 8px;
  height: 8px;
  margin-right: 8px;
  width: 8px;
`;

export const CheckMark = styled.span`
  color: var(--green-6);
  height: 8p;
  margin-right: 8px;
  width: 8px;
`;

export const LiContent = styled.span`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'unset')};
  color: ${({ bold }) => (bold ? 'var(--red-6)' : 'unset')};
`;

export const PASSWORD_VALIDATOR = () => ({
    validator(_, value) {
      if (executeRules(value).every(t => t === true)) {
        return Promise.resolve();
      }
      return Promise.reject();
    }
})

const PasswordInput = (props) => {
    const rules = executeRules(props.value);

    return <>
        <Input.Password
            {...props}
        />
        <Ul>
        {REQUIREMENTS.map((requirement, idx) => (
            <li key={`requirement ${idx}`}>
            <LiContainer
                data-cy={`requirement ${idx}`}
            >
                {!rules[idx] && <Circle data-cy="notValidated"/>}
                {rules[idx] === true && <CheckMark data-cy="validated">✓</CheckMark>}
                <LiContent 
                bold={rules[idx] === false}
                data-cy={requirement}
                >
                {requirement}
                </LiContent>
            </LiContainer>
            </li>
        ))}
        </Ul>
    </>
}

export default PasswordInput;